import React from 'react';
import './HomeBanner.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const HomeBanner = () => {
    const { t } = useTranslation();

    return (
        <section className="banner-section d-flex text-start">
            <div className="banner-overlay"></div>
            <div className="container text-start text-white m-0">
                <h1 className="banner-title ">
                    {t('homeBanner.title')}
                </h1>
                <p className="banner-lead w-75">
                    {t('homeBanner.lead')}
                </p>
                <Link to="/ContactUs" className="btn btn-success fw-bold banner-btn d-inline-flex align-items-center mb-2">
                    {t('homeBanner.contactButton')}&nbsp;
                    <FontAwesomeIcon icon={faArrowRight} />
                </Link>
            </div>
        </section>
    );
};

export default HomeBanner;
